import { Component, Input } from '@angular/core';
import { ThemeService } from '../../service/theme.service';

@Component({
  selector: 'app-login-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['../login.component.css', './login-form.component.css'],
  standalone: false,
})
export class LoginFormComponent {
  // Context bridge to parent login component (keeps logic centralized)
  @Input() ctx: any;
  @Input() loading = false;

  constructor(public theme: ThemeService) {}
}
